import { createAction } from '@reduxjs/toolkit';
export const threadSeen = createAction('threadSeen', payload => ({
  payload
}));
export const viewMemberSeen = createAction('viewMemberSeen', payload => ({
  payload
}));
export const viewMemberUnread = createAction('viewMemberUnread', payload => ({
  payload
}));